// Side-by-side preview route. Prefer the chat editor iframe; this route
// still opens the rendered preview in-tab for bookmarks / deep links.
// Customer-site framing is gated by the edge worker CSP frame-ancestors
// allowlist (platform/edge/router) — not X-Frame-Options: SAMEORIGIN.

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { forgePreviewUrl } from "../lib/domains";

export default function SitePreview() {
  const { siteId } = useParams<{ siteId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!siteId) return;
    let cancelled = false;
    (async () => {
      try {
        const site = await api.getSite(siteId);
        if (cancelled) return;
        const buildId = site.previewBuildId ?? site.liveBuildId;
        if (buildId) {
          window.location.replace(forgePreviewUrl(buildId));
          return;
        }
        navigate(`/sites/${siteId}`, { replace: true });
      } catch {
        if (!cancelled) navigate(`/sites/${siteId}`, { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [siteId, navigate]);

  return <div className="muted" style={{ padding: 24 }}>Opening preview…</div>;
}
